<template>
  <div
    class="fshr-gridItem"
    :class="[
      xxs && `fshr-gridItem--xxs-${xxs}`,
      // xs && `fshr-gridItem--xs-${xs}`,
      sm && `fshr-gridItem--sm-${sm}`,
      md && `fshr-gridItem--md-${md}`,
      // lg && `fshr-gridItem--lg-${lg}`,
      xl && `fshr-gridItem--xl-${xl}`,
      // xxl && `fshr-gridItem--xxl-${xxl}`,
    ]"
  >
    <slot />
  </div>
</template>

<script>
export default {
  /**
   Props for columns in grid system for search result list
   2021/03

   Currently we use only xxs, sm, md, xl breakpoints

   If other breakpoints will be needed please:
   - uncomment props,
   - uncomment additional classes in template
   - uncomment corresponding styles here
     src/nevdama/Scripts/source/vue/src/less/components/_component-grid-item.less
  */
  props: {
    /*
    Column width on screens starting from 0px width
     */
    xxs: {
      type: Number,
      required: false,
      default: 12,
    },
    /*
    Column width on screens starting from @screen-xs-min
     */
    // xs: {
    //   type: Number,
    //   required: false,
    //   default: null,
    // },
    /*
    Column width on screens starting from @screen-sm-min
     */
    sm: {
      type: Number,
      required: false,
      default: null,
    },
    /*
    Column width on screens starting from @screen-md-min
     */
    md: {
      type: Number,
      required: false,
      default: null,
    },
    /*
    Column width on screens starting from @screen-lg-min
     */
    // lg: {
    //   type: Number,
    //   required: false,
    //   default: null,
    // },
    /*
    Column width on screens starting from @screen-xl-min
     */
    xl: {
      type: Number,
      required: false,
      default: null,
    },
    /*
    Column width on screens starting from @screen-xxl-min
     */
    // xxl: {
    //   type: Number,
    //   required: false,
    //   default: null,
    // },
  },
};
</script>

<style scoped lang="less">
@import "../../less/components/_component-grid-item.less";
</style>
